export default class AccordionSideMenu {
  constructor(container) {
    this.container = document.querySelector(container);
    if (this.container) {
      this.menu = this.container.querySelectorAll(".side-menu .menu__item");
      this.images = this.container.querySelectorAll(".images .image");
      this.init();
    }
  }
  init() {
    this.activeFirst();
    this.activeMenu();
  }
  activeMenu() {
    for (let i = 0; i < this.menu.length; i++) {
      const menuItem = this.menu[i];
      menuItem.addEventListener("click", () => {
        for (const menuItem of this.menu) {
          menuItem.classList.remove("active");
        }

        let index = menuItem.getAttribute("data-item-index");

        for (const imageItem of this.images) {
          imageItem.classList.remove("active")
        }
        this.images[index].classList.add("active");

        menuItem.classList.add("active");
      });
    }
  }
  activeFirst() {
    this.menu[0].classList.add("active");
    this.images[0].classList.add("active");
  }
}
